import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Search, LayoutGrid, List, Download } from 'lucide-react';
import SubmMonthPicker from '@/components/zoho/submissions/SubmMonthPicker';

export default function SubmFilters({ viewMode, onViewChange, search, onSearch, month, onMonth, onExport }) {
  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3" data-testid="subm-filter-bar">
      <div className="relative flex-1 w-full sm:max-w-xs">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          placeholder="Search by name or ID..."
          value={search}
          onChange={function(e) { onSearch(e.target.value); }}
          className="pl-9 h-9 text-sm"
          data-testid="subm-search-input"
        />
      </div>

      <SubmMonthPicker value={month} onChange={onMonth} />

      <div className="flex items-center gap-2 ml-auto">
        <Button variant="outline" size="sm" className="h-9 gap-1.5 text-sm" onClick={onExport} data-testid="subm-export-btn">
          <Download className="h-3.5 w-3.5" /> Export
        </Button>
        <div className="flex border border-slate-200 rounded-lg overflow-hidden">
          <button
            onClick={function() { onViewChange('grid'); }}
            className={'p-2 transition-colors duration-150 ' + (viewMode === 'grid' ? 'bg-slate-900 text-white' : 'bg-white text-slate-500 hover:bg-slate-50')}
            data-testid="subm-view-grid"
          >
            <LayoutGrid className="h-4 w-4" />
          </button>
          <button
            onClick={function() { onViewChange('list'); }}
            className={'p-2 transition-colors duration-150 ' + (viewMode === 'list' ? 'bg-slate-900 text-white' : 'bg-white text-slate-500 hover:bg-slate-50')}
            data-testid="subm-view-list"
          >
            <List className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
